import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  Loading,
  InputCustom,
  InputMaskCustom,
  SelectCustom,
  TextArea,
  InputCurrency,
  HttpError
} from "../../components"
import Moment from "moment"
import Util from "../../Util"
import {
  UnidadesModal,
  ItensModal,
  GestoresModal,
  FiscaisModal,
  ContratadosModal,
  LoadModalWithLabel
} from "../modais"

import * as ApiHelper from "../../ApiHelper"
import * as constants from "../../constants"
import { ToastContainer, ToastMessage } from "react-toastr"
import InputDinheiroBR from "../../components/InputDinheiroBR"

class ContratosForm extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.getInitialFieldsEdit = this.getInitialFieldsEdit.bind(this)
    this.fillFields = this.fillFields.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.addItem = this.addItem.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.addAlert = this.addAlert.bind(this)
    this.onChangeFinalDaVigencia = this.onChangeFinalDaVigencia.bind(this)
    this.calculateValorGlobal = this.calculateValorGlobal.bind(this)
    this.calculateTotal = this.calculateTotal.bind(this)
    this.onChangeProcesso = this.onChangeProcesso.bind(this)
    this.onChangeContratado = this.onChangeContratado.bind(this)
    this.onChangeGestor = this.onChangeGestor.bind(this)
    this.onChangeFiscal = this.onChangeFiscal.bind(this)
    this.onChangePreposto = this.onChangePreposto.bind(this)
    this.onChangeUnidade = this.onChangeUnidade.bind(this)
    this.onChangeNumeroDoContrato = this.onChangeNumeroDoContrato.bind(this)
    this.onChangeObjeto = this.onChangeObjeto.bind(this)
    this.onChangeModalidade = this.onChangeModalidade.bind(this)
    this.onChangeTipo = this.onChangeTipo.bind(this)
    this.onChangeAssinado = this.onChangeAssinado.bind(this)
    this.onChangeInicioExecucao = this.onChangeInicioExecucao.bind(this)
    this.onChangeEmExecucao = this.onChangeEmExecucao.bind(this)
    this.onChangeExecucao = this.onChangeExecucao.bind(this)
    this.onChangeLocalExtracao = this.onChangeLocalExtracao.bind(this)
    this.onChangePublicacao = this.onChangePublicacao.bind(this)
    this.onChangeDescricaoItem = this.onChangeDescricaoItem.bind(this)
    this.onChangeValorUnitarioItem = this.onChangeValorUnitarioItem.bind(this)
    this.onChangeQuantidadeItem = this.onChangeQuantidadeItem.bind(this)
    this.onChangeUnidadeDeMedidaItem = this.onChangeUnidadeDeMedidaItem.bind(
      this
    )
    this.onChangeObservacao = this.onChangeObservacao.bind(this)
    this.onBlurNumeroDoContrato = this.onBlurNumeroDoContrato.bind(this)
    this.getInitialFields = this.getInitialFields.bind(this)
    this.reloadUnidades = this.reloadUnidades.bind(this)
    this.toggleUnidadesModal = this.toggleUnidadesModal.bind(this)
    this.reloadGestores = this.reloadGestores.bind(this)
    this.toggleGestoresModal = this.toggleGestoresModal.bind(this)
    this.reloadFiscais = this.reloadFiscais.bind(this)
    this.toggleFiscaisModal = this.toggleFiscaisModal.bind(this)
    this.reloadContratados = this.reloadContratados.bind(this)
    this.toggleContratadosModal = this.toggleContratadosModal.bind(this)
    this.toggleItensModal = this.toggleItensModal.bind(this)
    this.reloadItem = this.reloadItem.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showUnidadesModal: false,
      showGestoresModal: false,
      showFiscaisModal: false,
      showContratadosModal: false,
      showItemModal: false,
      editingItem: "",
      prepostos: [],
      preposto: "",
      numeroDoProcesso: "",
      numeroDoContrato: "",
      showForm: false,
      contratados: [],
      unidades: [],
      tipos: [],
      modalidades: [],
      gestores: [],
      fiscais: [],
      unidadesDeMedida: [],
      contratado: "",
      unidade: "",
      tipo: "",
      modalidade: "",
      gestor: "",
      fiscal: "",
      localExtracao: "",
      publicacao: "",
      observacao: "",
      itens: [],
      currentItens: [],
      itens_de_contratosError: []
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
  }
  shouldSelectUnidadeOrcamentaria() {
    return (
      constants.haveRole(1) ||
      constants.getUserUniOrc().length > 1
    )
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Contrato atualizado com sucesso"
    } else {
      message = "Contrato cadastrado com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    ApiHelper.getMe((error) => {
      if (!error) {
        if (this.props.isEditing) {
          this.getInitialFieldsEdit()
        } else {
          this.getInitialFields()
        }
      }
    })

  }
  getInitialFieldsEdit() {
    ApiHelper.getEditFieldsContrato(
      this.props.match.params.id,
      (fields, error) => {
        if (fields) {
          this.setState(
            {
              showForm: true,
              contratados: fields.contratados,
              unidades: fields.unidades,
              tipos: fields.tipos,
              modalidades: fields.modalidades,
              gestores: fields.gestores,
              fiscais: fields.fiscais,
              unidadesDeMedida: fields.unidadesDeMedida
            },
            () => {
              this.fillFields(fields.contrato)
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  getInitialFields() {
    ApiHelper.getCreateFieldsContrato((fields, error) => {
      if (fields) {
        this.setState(
          {
            showForm: true,
            contratados: fields.contratados,
            unidades: fields.unidades,
            tipos: fields.tipos,
            modalidades: fields.modalidades,
            gestores: fields.gestores,
            fiscais: fields.fiscais,
            unidadesDeMedida: fields.unidadesDeMedida,
            httpError: undefined
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  fillFields(fields) {
    var currentItens = fields.itens_de_contratos
    var itens = []
    currentItens.forEach(item => {
      var itemMapped = {
        id: item.id,
        descricao: item.descricao,
        valor_unitario: Util.remaskCurrency(item.valor_unitario),
        unidadeDeMedida: item.unidade_de_medida_id,
        quantidade: item.quantidade,
        valor: item.valor
      }
      itens.push(itemMapped)
    })
    var prepostos = this.getContratadoById(fields.contratado_id).prepostos
    var currentFields = {
      numeroDoContrato: fields.num_contrato,
      numeroDoProcesso: fields.num_processo,
      objeto: fields.objeto,
      modalidade: fields.modalidade_licitacao_id,
      tipo: fields.tipo_contrato_id,
      gestor: fields.gestor_id,
      prepostos: prepostos,
      preposto: fields.preposto_id,
      fiscal: fields.fiscal_id,
      unidade: fields.unidade_orcamentaria_id,
      contratado: fields.contratado_id,
      assinadoEm: fields.data_assinado,
      inicioExecucao: fields.inicio_execucao || undefined,
      finalExecucao: fields.final_execucao || undefined,
      emExecucao: fields.em_execucao || undefined,
      execucao: fields.execucao || undefined,
      finalDaVigencia: fields.final_vigencia.date,
      publicacao: fields.data_publicacao_extrato,
      localExtracao: fields.local_extracao,
      inicioDaObra: fields.inicio_obra_servico || undefined,
      finalDaObra: fields.fim_obra_servico || undefined,
      observacao: fields.observacao || undefined,
      valorGlobal: Util.remaskCurrency(fields.valor_global),
      currentItens: itens,
      showForm: true
    }
    this.setState(currentFields)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  sendForm(event) {
    event.preventDefault()
    var itens = []
    this.state.itens.forEach(item => {
      itens.push({
        descricao: item.descricao,
        quantidade: item.quantidade,
        valor_unitario: item.valor_unitario,
        valor: item.valor,
        unidade_de_medida_id: item.unidadeDeMedida
      })
    })
    var parameters = {
      num_contrato: this.state.numeroDoContrato,
      num_processo: this.state.numeroDoProcesso,
      objeto: this.state.objeto,
      preposto_id: this.state.preposto,
      modalidade_licitacao_id: this.state.modalidade,
      tipo_contrato_id: this.state.tipo,
      gestor_id: this.state.gestor,
      fiscal_id: this.state.fiscal,
      unidade_orcamentaria_id: this.shouldSelectUnidadeOrcamentaria() ? this.state.unidade : constants.getUserUniOrc()[0],
      contratado_id: this.state.contratado,
      data_assinado: Util.dateOnly(this.state.assinadoEm),
      inicio_execucao: Util.dateOnly(this.state.inicioExecucao),
      final_execucao: Util.dateOnly(this.state.finalExecucao),
      em_execucao: this.state.emExecucao,
      execucao: this.state.execucao,
      final_vigencia: Util.dateOnly(this.state.finalDaVigencia),
      data_publicacao_extrato: Util.dateOnly(this.state.publicacao),
      local_extracao: this.state.localExtracao,
      observacao: this.state.observacao,
      valor_global:
        typeof this.state.valorGlobal === "string"
          ? Util.unmaskCurrency(this.state.valorGlobal)
          : this.state.valorGlobal,
      itens_de_contratos: itens
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateContrato(
        parameters,
        this.props.match.params.id,
        errors => {
          this.toggleLoadModal()
          if (errors) {
            this.showErrorMessage()
            this.handleErrors(errors)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBackContratos()
            })
          }
        }
      )
    } else {
      ApiHelper.createNewContrato(parameters, errors => {
        this.toggleLoadModal()
        if (errors) {
          this.showErrorMessage()
          this.handleErrors(errors)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackContratos()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    var itens_de_contratosError = []
    this.state.itens.forEach(() => {
      itens_de_contratosError.push({
        descricao: "",
        valor_unitario: "",
        unidadeDeMedida: "",
        quantidade: "",
        valor: ""
      })
    })
    for (var key in errorsValue) {
      if (key.includes("itens_de_contratos.")) {
        var index = key.split("itens_de_contratos.").join("")
        if (index.includes(".descricao")) {
          index = index.split(".descricao").join("")
          itens_de_contratosError[index].descricao = errorsValue[key][0]
        }
        if (index.includes(".valor_unitario")) {
          index = index.split(".valor_unitario").join("")
          itens_de_contratosError[index].valor_unitario = errorsValue[key][0]
        }
        if (index.includes(".unidade_de_medida_id")) {
          index = index.split(".unidade_de_medida_id").join("")
          itens_de_contratosError[index].unidadeDeMedida = errorsValue[key][0]
        }
        if (index.includes(".quantidade")) {
          index = index.split(".quantidade").join("")
          itens_de_contratosError[index].quantidade = errorsValue[key][0]
        }
      } else {
        errorsState[key + "Error"] = errorsValue[key][0]
      }
    }
    errorsState.itens_de_contratosError = itens_de_contratosError
    this.setState(errorsState)
  }
  //Modal de unidades orçamentárias
  toggleUnidadesModal() {
    this.setState({ showUnidadesModal: !this.state.showUnidadesModal })
  }
  reloadUnidades(unidades) {
    var newUnidades = Util.mapUnidades(unidades)
    this.setState({ showUnidadesModal: false, unidades: newUnidades })
  }
  //Modal de gestores
  toggleGestoresModal() {
    this.setState({ showGestoresModal: !this.state.showGestoresModal })
  }
  reloadGestores(values) {
    var newValues = Util.mapGestores(values)
    this.setState({ showGestoresModal: false, gestores: newValues })
  }
  //Modal de fiscais
  toggleFiscaisModal() {
    this.setState({ showFiscaisModal: !this.state.showFiscaisModal })
  }
  reloadFiscais(values) {
    var newValues = Util.mapGestores(values)
    this.setState({ showFiscaisModal: false, fiscais: newValues })
  }
  //Modal de fiscais
  toggleContratadosModal() {
    this.setState({ showContratadosModal: !this.state.showContratadosModal })
  }
  reloadContratados(values) {
    var newValues = Util.mapContratados(values)
    this.setState({ showContratadosModal: false, contratados: newValues })
  }
  //Modal de itens de contrato
  toggleItensModal(event, index) {
    if(event != null){
      event.preventDefault()
    }
    var editingItem = this.state.currentItens[index]
    this.setState({
      editingItem: editingItem,
      showItemModal: !this.state.showItemModal
    })
  }
  reloadItem(value) {
    var newValorGlobal = parseFloat(value.contrato.valor_global)
    var changedItem = {
      id: value.id,
      descricao: value.descricao,
      valor_unitario: Util.remaskCurrency(value.valor_unitario),
      unidadeDeMedida: value.unidade_de_medida_id,
      quantidade: value.quantidade,
      valor: Util.formatCurrency(value.valor)
    }
    var currentItens = this.state.currentItens
    currentItens.forEach((item, index) => {
      if (item.id === value.id) {
        currentItens[index] = changedItem
      }
    })
    this.setState({
      showItemModal: false,
      currentItens: currentItens,
      valorGlobal: newValorGlobal,
      editingItem: ""
    })
  }
  getContratadoById(id) {
    return this.state.contratados.filter(contratado => {
      return "" + contratado.value === "" + id
    })[0]
  }
  onChangeProcesso(event) {
    var newValue = event.target.value
    this.setState({ num_processoError: "", numeroDoProcesso: newValue })
  }
  onChangeContratado(event) {
    var newValue = event.target.value
    var prepostos = this.getContratadoById(newValue).prepostos
    this.setState({
      contratado_idError: "",
      contratado: newValue,
      prepostos: prepostos,
      preposto: undefined
    })
  }
  onChangeGestor(event) {
    var newValue = event.target.value
    this.setState({ gestor_idError: "", gestor: newValue })
  }
  onChangeFiscal(event) {
    var newValue = event.target.value
    this.setState({ fiscal_idError: "", fiscal: newValue })
  }
  onChangeUnidade(event) {
    var newValue = event.target.value
    this.setState({ unidade_orcamentaria_idError: "", unidade: newValue })
  }
  onChangeObjeto(event) {
    var newValue = event.target.value
    this.setState({ objetoError: "", objeto: newValue })
  }
  onChangeObservacao(event) {
    var newValue = event.target.value
    this.setState({ observacao: newValue })
  }
  onChangeNumeroDoContrato(event) {
    var newValue = event.target.value
    this.setState({ num_contratoError: "", numeroDoContrato: newValue })
  }
  onBlurNumeroDoContrato() {
    const unidadeOrcamentariaId = this.shouldSelectUnidadeOrcamentaria() ? this.state.unidade : constants.getUserUniOrc()[0]
    ApiHelper.existsContrato(
      this.state.numeroDoContrato,
      unidadeOrcamentariaId,
      this.props.isEditing ? this.props.match.params.id : undefined,
      (data, error) => {
        if (error) {
          console.log(error)
        } else {
          this.setState({
            existsContrato: data.exists
          })
        }
      }

    )
  }
  onChangeModalidade(event) {
    var newValue = event.target.value
    this.setState({ modalidade_licitacao_idError: "", modalidade: newValue })
  }
  onChangeTipo(event) {
    var newValue = event.target.value
    this.setState({ tipo_contrato_idError: "", tipo: newValue })
  }
  onChangeAssinado(value) {
    var newValue = value
    this.setState({ data_assinadoError: "", assinadoEm: newValue })
  }
  onChangeFinalDaVigencia(value) {
    var newValue = value
    this.setState({
      final_vigenciaError: "",
      finalDaVigencia: newValue,
      final_execucaoError: ""
    })
  }
  onChangeInicioExecucao(value) {
    console.log(value)
    var newValue = value
    this.setState(
      {
        inicio_execucaoError: "",
        inicioExecucao: newValue,
        final_execucaoError: ""
      },
      () => {
        this.calculateFinalExecucao()
      }
    )
  }
  onChangeExecucao(event) {
    var newValue = event.target.value
    this.setState(
      { execucaoError: "", execucao: newValue, final_execucaoError: "" },
      () => {
        this.calculateFinalExecucao()
      }
    )
  }
  onChangeEmExecucao(event) {
    var newValue = event.target.value
    this.setState(
      { em_execucaoError: "", emExecucao: newValue, final_execucaoError: "" },
      () => {
        this.calculateFinalExecucao()
      }
    )
  }
  onChangePublicacao(value) {
    var newValue = value
    this.setState({ data_publicacao_extratoError: "", publicacao: newValue })
  }
  onChangeLocalExtracao(event) {
    var newValue = event.target.value
    this.setState({ local_extracaoError: "", localExtracao: newValue })
  }
  onChangeValorUnitarioItem(event, index, value) {

    var newValue = value
    var oldItens = this.state.itens
    var newState = []
    oldItens[index].valor_unitario = newValue
    newState.itens = oldItens

    if (this.state.itens_de_contratosError[index]) {
      var oldErrors = this.state.itens_de_contratosError
      oldErrors[index].valor_unitario = ""
      newState.itens_de_contratosError = oldErrors
    }
    newState.itens[index].valor = newValue * newState.itens[index].quantidade;


    this.setState(newState, () => {

      this.calculateTotal(index)
    })
  }
  onChangeQuantidadeItem(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itens
    var newState = []
    oldItens[index].quantidade = newValue
    newState.itens = oldItens
    if (this.state.itens_de_contratosError[index]) {
      var oldErrors = this.state.itens_de_contratosError
      oldErrors[index].quantidade = ""
      newState.itens_de_contratosError = oldErrors
    }

    this.setState(newState, () => {
      this.calculateTotal(index)
    })
  }
  onChangeUnidadeDeMedidaItem(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itens
    var newState = []
    oldItens[index].unidadeDeMedida = newValue
    newState.itens = oldItens
    if (this.state.itens_de_contratosError[index]) {
      var oldErrors = this.state.itens_de_contratosError
      oldErrors[index].unidadeDeMedida = ""
      newState.itens_de_contratosError = oldErrors
    }
    this.setState(newState, () => {
      this.calculateTotal(index)
    })
  }
  onChangeDescricaoItem(event, index) {
    var newValue = event.target.value
    var oldItens = this.state.itens
    var newState = []
    oldItens[index].descricao = newValue
    newState.itens = oldItens
    if (this.state.itens_de_contratosError[index]) {
      var oldErrors = this.state.itens_de_contratosError
      oldErrors[index].descricao = ""
      newState.itens_de_contratosError = oldErrors
    }
    this.setState(newState, () => {
      this.calculateTotal(index)
    })
  }
  calculateValorGlobal() {

    var valorGlobal = 0
    this.state.currentItens.forEach(item => {
      valorGlobal += parseFloat(item.valor)
    })
    this.state.itens.forEach(item => {
      valorGlobal += parseFloat(item.valor)
    })
    this.setState({ valor_globalError: "", valorGlobal: valorGlobal })
  }
  calculateTotal(index) {

    var oldItens = this.state.itens
    var quantidade = oldItens[index].quantidade
    var valorUnitario = oldItens[index].valor_unitario
    if(quantidade.toString().trim() == "" || quantidade == null)
      quantidade = 0

    if(valorUnitario.toString().trim() == "" || valorUnitario == null)
      valorUnitario = 0

      var valorTotal = valorUnitario * quantidade
      oldItens[index].valor = valorTotal
      this.setState(
        {
          itens: oldItens
        },
        () => {
          this.calculateValorGlobal()
        }
      )

  }
  addItem(event) {
    event.preventDefault()
    var oldItens = this.state.itens
    oldItens.push({
      descricao: "",
      valor_unitario: "",
      unidadeDeMedida: "",
      quantidade: "",
      valor: ""
    })
    this.setState(
      {
        itens: oldItens
      },
      () => {
        var refIndex = "item" + (oldItens.length - 1)
        if (this.refs[refIndex]) {
          this.refs[refIndex].scrollIntoView({ behavior: "smooth" })
        }

      }
    )
  }
  onChangePreposto(event) {
    var newValue = event.target.value
    this.setState({ preposto_idError: "", preposto: newValue })
  }
  removeItem(key) {
    var oldItens = this.state.itens
    oldItens.splice(key, 1)
    this.setState(
      {
        itens: oldItens
      },
      () => {
        var refIndex = "item" + (oldItens.length - 1)
        if (this.refs[refIndex]) {
          this.refs[refIndex].scrollIntoView({ behavior: "smooth" })
        }
        this.calculateValorGlobal()
      }
    )
  }
  calculateFinalExecucao() {
    if (
      this.state.inicioExecucao &&
      this.state.execucao &&
      this.state.emExecucao
    ) {
      var inicioExecucao = Moment(this.state.inicioExecucao)
      var finalExecucao = inicioExecucao
        .add(this.state.execucao, this.state.emExecucao)
        .format("YYYY-MM-DD")
      this.setState({ finalExecucao: finalExecucao })
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  removeCurrentItem(event, index, id) {
    event.preventDefault()
    ApiHelper.deleteItemDeContrato(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        var currentItens = this.state.currentItens
        var itemValue = currentItens[index].valor
        currentItens.splice(index, 1)
        var valorGlobal =
          typeof this.state.valorGlobal === "string"
            ? Util.unmaskCurrency(this.state.valorGlobal)
            : this.state.valorGlobal
        valorGlobal -= itemValue
        this.setState({
          valorGlobal: valorGlobal,
          currentItens: currentItens
        })
      }
    })
  }
  render() {
    var execucao = [
      { label: "", value: null },
      { label: "Dia(s)", value: "days" },
      { label: "Mês(es)", value: "months" },
      { label: "Ano(s)", value: "years" }
    ]
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div>
          <div className="card card-plain">
            <div className="card-header" data-background-color="as-blue">
              <ToastContainer
                ref={input => {
                  this.container = input
                }}
                toastMessageFactory={this.toastFactory}
                className="toast-top-right"
                preventDuplicates={true}
              />
              <h4 className="title">
                {this.props.isEditing ? "Editar contrato" : "Criar contrato"}
              </h4>
              <p className="category">
                {this.props.isEditing
                  ? "Contrato:  " + (this.state.objeto || "")
                  : "Criar novo gestor de contrato"}
              </p>
            </div>
            <div className="card-content">
              <ContratadosModal
                callBack={this.reloadContratados}
                show={this.state.showContratadosModal}
                onClose={this.toggleContratadosModal}
              />
              <GestoresModal
                callBack={this.reloadGestores}
                show={this.state.showGestoresModal}
                onClose={this.toggleGestoresModal}
              />
              <FiscaisModal
                callBack={this.reloadFiscais}
                show={this.state.showFiscaisModal}
                onClose={this.toggleFiscaisModal}
              />
              <UnidadesModal
                callBack={this.reloadUnidades}
                show={this.state.showUnidadesModal}
                onClose={this.toggleUnidadesModal}
              />
              <ItensModal
                editingItem={this.state.editingItem}
                callBack={this.reloadItem}
                show={this.state.showItemModal}
                onClose={this.toggleItensModal}
              />
              <form>
                {this.state.showForm === false ? (
                  <div className="row">
                    <Loading />
                  </div>
                ) : (
                    <div>
                      <div className="row">
                        <InputCustom
                          error={this.state.num_contratoError || (this.state.existsContrato ? "Já existe um contrato cadastrado com esse número" : undefined)}
                          sizeClass="col-md-2"
                          label={"Número do contrato"}
                          type="number"
                          onChange={this.onChangeNumeroDoContrato}
                          onBlur={this.onBlurNumeroDoContrato}
                          value={this.state.numeroDoContrato}
                        />
                        <InputMaskCustom
                          error={this.state.num_processoError}
                          mask={constants.getMaskNumProcesso()}
                          sizeClass="col-md-2"
                          label="Número do processo"
                          type="text"
                          onChange={this.onChangeProcesso}
                          value={this.state.numeroDoProcesso}
                        />
                        <SelectCustom
                          error={this.state.modalidade_licitacao_idError}
                          sizeClass="col-md-3"
                          options={this.state.modalidades}
                          label={"Modalidade"}
                          onChange={this.onChangeModalidade}
                          value={this.state.modalidade}
                        />
                        {
                          this.shouldSelectUnidadeOrcamentaria() &&
                          <SelectCustom
                            error={this.state.unidade_orcamentaria_idError}
                            sizeClass="col-md-3"
                            options={this.state.unidades}
                            onBlur={this.onBlurNumeroDoContrato}
                            label="Unidade orçamentária"
                            onChange={this.onChangeUnidade}
                            value={this.state.unidade}
                          />
                        }

                        {constants.haveRole(1) && (
                          <div>
                            <button
                              onClick={this.toggleUnidadesModal}
                              style={{ width: "4%" }}
                              type="button"
                              rel="tooltip"
                              title="Criar unidade orcamentária"
                              className="btn btn-success btn-simple btn-xs col-md-1"
                            >
                              <i
                                className="icon-header material-icons"
                                style={{ fontSize: 20 }}
                              >
                                control_point
                            </i>
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <SelectCustom
                          error={this.state.tipo_contrato_idError}
                          sizeClass="col-md-3"
                          options={this.state.tipos}
                          label={"Tipo de contrato"}
                          onChange={this.onChangeTipo}
                          value={this.state.tipo}
                        />
                        <SelectCustom
                          error={this.state.contratado_idError}
                          sizeClass="col-md-4"
                          options={this.state.contratados}
                          label="Contratado"
                          onChange={this.onChangeContratado}
                          value={this.state.contratado}
                        />
                        <button
                          onClick={this.toggleContratadosModal}
                          style={{ width: "4%" }}
                          type="button"
                          rel="tooltip"
                          title="Criar contratado"
                          className="btn btn-success btn-simple btn-xs col-md-1"
                        >
                          <i
                            className="icon-header material-icons"
                            style={{ fontSize: 20, top: 18, right: 25 }}
                          >
                            control_point
                        </i>
                        </button>
                        <SelectCustom
                          error={this.state.preposto_idError}
                          sizeClass="col-md-3"
                          options={this.state.prepostos}
                          label="Preposto"
                          onChange={this.onChangePreposto}
                          value={this.state.preposto}
                        />
                      </div>
                      <div className="row">
                        <SelectCustom
                          error={this.state.gestor_idError}
                          sizeClass="col-md-3"
                          options={this.state.gestores}
                          label="Gestor"
                          onChange={this.onChangeGestor}
                          value={this.state.gestor}
                        />
                        {constants.haveRole(1) && (
                          <div>
                            <button
                              onClick={this.toggleGestoresModal}
                              style={{ width: "4%" }}
                              type="button"
                              rel="tooltip"
                              title="Criar gestor"
                              className="btn btn-success btn-simple btn-xs col-md-1"
                            >
                              <i
                                className="icon-header material-icons"
                                style={{ fontSize: 20, top: 18, right: 25 }}
                              >
                                control_point
                            </i>
                            </button>
                          </div>
                        )}

                        <SelectCustom
                          error={this.state.fiscal_idError}
                          sizeClass="col-md-3"
                          options={this.state.fiscais}
                          label="Fiscal"
                          onChange={this.onChangeFiscal}
                          value={this.state.fiscal}
                        />
                        {(constants.haveRole(1) || constants.haveRole(3)) && (
                          <div>
                            <button
                              onClick={this.toggleFiscaisModal}
                              style={{ width: "4%" }}
                              type="button"
                              rel="tooltip"
                              title="Criar fiscal"
                              className="btn btn-success btn-simple btn-xs col-md-1"
                            >
                              <i
                                className="icon-header material-icons"
                                style={{ fontSize: 20, top: 18, right: 25 }}
                              >
                                control_point
                            </i>
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <TextArea
                          error={this.state.objetoError}
                          sizeClass="col-md-11"
                          subTitle="Descrição do contrato"
                          label="Objeto do contrato"
                          onChange={this.onChangeObjeto}
                          value={this.state.objeto}
                        />
                      </div>
                      <div className="row">
                        <div className="card" data-background-color="light-blue">
                          <div
                            className="card-header"
                            data-background-color="as-blue"
                          >
                            <h4 className="title">Datas e vigência</h4>
                            <p className="category">
                              Informações relacionadas aos prazos do contrato
                          </p>
                          </div>
                          <div className="card-content">
                            <div className="row">
                              <InputCustom
                                error={this.state.data_assinadoError}
                                sizeClass="col-md-2"
                                label={"Assinado em"}
                                type="date"
                                onChange={this.onChangeAssinado}
                                value={this.state.assinadoEm}
                              />
                              {}
                              <InputCustom
                                error={this.state.inicio_execucaoError}
                                sizeClass="col-md-2"
                                label={"Início da execução"}
                                type="date"
                                onChange={this.onChangeInicioExecucao}
                                value={this.state.inicioExecucao}
                              />
                              <InputCustom
                                error={this.state.execucaoError}
                                sizeClass="col-md-2"
                                label="Execução"
                                type="number"
                                onChange={this.onChangeExecucao}
                                value={this.state.execucao}
                              />
                              <SelectCustom
                                error={this.state.em_execucaoError}
                                sizeClass="col-md-3"
                                options={execucao}
                                label={"Em"}
                                onChange={this.onChangeEmExecucao}
                                value={this.state.emExecucao}
                              />
                              <InputCustom
                                error={this.state.final_execucaoError}
                                sizeClass="col-md-2"
                                label={"Final da execução"}
                                type="date"
                                value={this.state.finalExecucao}
                                disabled={true}
                              />
                            </div>
                            <div className="row">
                              <InputCustom
                                error={this.state.final_vigenciaError}
                                sizeClass="col-md-2"
                                label={"Final da vigência"}
                                type="date"
                                onChange={this.onChangeFinalDaVigencia}
                                value={this.state.finalDaVigencia}
                              />
                            </div>
                            <div className="row">
                              <InputCustom
                                error={this.state.data_publicacao_extratoError}
                                sizeClass="col-md-2"
                                label={"Data da publicação do extrato"}
                                type="date"
                                onChange={this.onChangePublicacao}
                                value={this.state.publicacao}
                              />
                              <InputCustom
                                error={this.state.local_extracaoError}
                                sizeClass="col-md-2"
                                label={"Local de publicação do extrato"}
                                type="text"
                                onChange={this.onChangeLocalExtracao}
                                value={this.state.localExtracao}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="card" data-background-color="light-blue">
                          <div
                            className="card-header"
                            data-background-color="as-blue"
                          >
                            <h4 className="title">Itens de contrato</h4>

                            <p className="category" />
                          </div>
                          <div className="card-content">

                            {this.state.currentItens.map((item, key) => {
                              return (
                                <div
                                  key={key}
                                  className="card"
                                  data-background-color="light-blue"
                                >
                                  <div className="card-content card-item">
                                    <div className="row">
                                      <TextArea
                                        rows="2"
                                        sizeClass="col-md-10"
                                        label={"Descrição do item"}
                                        value={
                                          this.state.currentItens[key].descricao
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                    <div className="row">
                                      <InputCustom
                                        sizeClass="col-md-2"
                                        label={"Valor Unitário"}
                                        value={Util.formatCurrency(
                                          this.state.currentItens[key]
                                            .valor_unitario
                                        )}
                                        disabled={true}
                                      />
                                      <InputCustom
                                        type="number"
                                        sizeClass="col-md-2"
                                        label="Quantidade"
                                        value={
                                          parseFloat(this.state.currentItens[key].quantidade)
                                        }
                                        disabled={true}
                                      />
                                      <SelectCustom
                                        sizeClass="col-md-1"
                                        options={this.state.unidadesDeMedida}
                                        label={"Unidade de medida"}
                                        value={
                                          this.state.currentItens[key]
                                            .unidadeDeMedida
                                        }
                                        disabled={true}
                                      />
                                      <InputCustom
                                        sizeClass="col-md-5"
                                        label={"Valor total do item"}
                                        disabled={true}
                                        value={Util.formatCurrency(
                                          this.state.currentItens[key].valor
                                        )}
                                      />
                                    </div>
                                    <div className="row">
                                      <button
                                        title="Remover item"
                                        onClick={event =>
                                          this.removeCurrentItem(
                                            event,
                                            key,
                                            item.id
                                          )
                                        }
                                        className="btn btn-danger pull-left"
                                        data-background-color="red"
                                      >
                                        <i className="icon-header material-icons">
                                          delete
                                      </i>
                                      </button>
                                      <button
                                        title="Editar item"
                                        onClick={event =>
                                          this.toggleItensModal(
                                            event,
                                            key,
                                            item.id
                                          )
                                        }
                                        className="btn btn-danger pull-left"
                                        data-background-color="blue"
                                      >
                                        <i className="icon-header material-icons">
                                          create
                                      </i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                            {this.state.itens.map((item, key) => {
                              return (
                                <div
                                  ref={"item" + key}
                                  key={key}
                                  className="card card-item"
                                  data-background-color="light-blue"
                                >
                                  <div className="card-content card-item">
                                    <div className="row">
                                      <TextArea
                                        error={
                                          this.state.itens_de_contratosError[key]
                                            ? this.state.itens_de_contratosError[
                                              key
                                            ].descricao
                                            : ""
                                        }
                                        rows="2"
                                        sizeClass="col-md-10"
                                        label={"Descrição do item"}
                                        onChange={event =>
                                          this.onChangeDescricaoItem(event, key)
                                        }
                                        value={this.state.itens[key].descricao}
                                      />
                                    </div>
                                    <div className="row">

                                      <InputDinheiroBR
                                          err ={this.state.itens_de_contratosError}
                                        error={
                                          this.state.itens_de_contratosError[key] ? this.state.itens_de_contratosError[key].valor_unitario
                                            : ""
                                        }
                                        sizeClass="col-md-2"
                                        label={"Valor Unitário"}
                                        onChange={( valueFormatado,value) =>
                                          this.onChangeValorUnitarioItem(
                                            undefined,
                                            key,
                                            value
                                          )
                                        }
                                        defaultValue={
                                          this.state.itens[key].valor_unitario
                                        }
                                      />
                                      <InputCustom
                                        error={
                                          this.state.itens_de_contratosError[key]
                                            ? this.state.itens_de_contratosError[
                                              key
                                            ].quantidade
                                            : ""
                                        }
                                        type="number"
                                        sizeClass="col-md-2"
                                        label="Quantidade"
                                        onChange={event =>
                                          this.onChangeQuantidadeItem(event, key)
                                        }
                                        value={this.state.itens[key].quantidade}
                                      />
                                      <SelectCustom
                                        error={
                                          this.state.itens_de_contratosError[key]
                                            ? this.state.itens_de_contratosError[
                                              key
                                            ].unidadeDeMedida
                                            : ""
                                        }
                                        sizeClass="col-md-1"
                                        options={this.state.unidadesDeMedida}
                                        label={"Unidade de medida"}
                                        onChange={event =>
                                          this.onChangeUnidadeDeMedidaItem(
                                            event,
                                            key
                                          )
                                        }
                                        value={
                                          this.state.itens[key].unidadeDeMedida
                                        }
                                      />
                                      <InputCustom
                                        error={
                                          this.state.itens_de_contratosError[key]
                                            ? this.state.itens_de_contratosError[
                                              key
                                            ].valor
                                            : ""
                                        }
                                        sizeClass="col-md-5"
                                        label={"Valor total do item"}
                                        disabled={true}
                                        value={Util.formatCurrency(
                                          this.state.itens[key].valor
                                        )}
                                      />
                                    </div>
                                    <div className="row">
                                      <button
                                        type="button"
                                        onClick={e => this.removeItem(key)}
                                        style={{ marginLeft: 20 }}
                                        className="btn btn-danger"
                                        title="Remove item"
                                        data-background-color="red"
                                      >
                                        <i className="icon-header material-icons">
                                          delete
                                      </i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}

                            <button
                              onClick={this.addItem}
                              type="button"
                              className="btn btn-primary pull-right"
                              data-background-color="green"
                            >
                              <i className="icon-header material-icons">add</i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <TextArea
                          sizeClass="col-md-11"
                          label="Observações"
                          subTitle="Observações a serem adicionadas ao contrato"
                          onChange={this.onChangeObservacao}
                          value={this.state.observacao}
                        />
                      </div>
                      <div className="row">
                        <InputCustom
                          error={this.state.valor_globalError}
                          sizeClass="col-md-5"
                          label={"Valor global"}
                          disabled={true}
                          value={Util.formatCurrency(this.state.valorGlobal)}
                        />
                      </div>
                      <div className="row">
                        <button
                          onClick={this.sendForm}
                          type="submit"
                          className="btn btn-primary pull-left"
                          data-background-color="as-blue"
                        >
                          {this.props.isEditing ? "Salvar" : "Criar"}
                        </button>
                      </div>
                      <div className="clearfix" />
                    </div>
                  )}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(ContratosForm)



// WEBPACK FOOTER //
// ./src/views/modais/ContratosForm.js